import styled from 'styled-components'

import { Card as DefaultCard } from 'components/Layout'

export const Card = styled(DefaultCard)`
	width: 100%;
`
